export enum ToastType {
  Success,
  Error,
}

export type EventFC<P = unknown> = (params: P) => void

class EventEmitter<P = unknown> {
  private events = {} as Record<EventEmit, EventFC<P>[]>

  on(event: EventEmit, listener: EventFC<P>) {
    if (!this.events[event]) this.events[event] = []
    this.events[event].push(listener)
  }

  off(event: EventEmit, listener: EventFC<P>) {
    if (!this.events[event]) return
    this.events[event] = this.events[event].filter((l) => l !== listener)
  }

  emit(event: EventEmit, data: P) {
    if (!this.events[event]) return
    this.events[event].forEach((listener) => listener(data))
  }
}

export const eventEmitter = new EventEmitter<{
  message: string
  type: ToastType
}>()

export enum EventEmit {
  Toast = 'showToast',
}

export const showToast = {
  success: (message: string) => {
    eventEmitter.emit(EventEmit.Toast, { message, type: ToastType.Success })
  },
  error: (message: string) => {
    eventEmitter.emit(EventEmit.Toast, { message, type: ToastType.Error })
  },
}
